import type { CategoryId, LifeItem } from './models'
import { toDateKey } from './lib/date'

export const CATEGORY_META: Record<CategoryId, { label: string; icon: string; color: string }> = {
  general: { label: '일반', icon: '📌', color: '#687078' },
  family: { label: '가족', icon: '👨‍👩‍👧', color: '#8b63b6' },
  shopping: { label: '장보기', icon: '🛒', color: '#d97724' },
  home: { label: '집안일', icon: '🏠', color: '#3477a8' },
  outing: { label: '외출', icon: '🚗', color: '#2d8c73' },
  celebration: { label: '기념일', icon: '🎉', color: '#c75478' },
  hobby: { label: '취미', icon: '🎨', color: '#6f78c7' },
  routine: { label: '생활 루틴', icon: '✅', color: '#4f8a45' },
}

export function createSeedItems(today = new Date()): LifeItem[] {
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  return [
    {
      id: 'welcome-family',
      title: '가족에게 전화하기',
      date: toDateKey(today),
      time: '10:30',
      kind: 'schedule',
      category: 'family',
      completedDates: [],
      repeat: 'none',
    },
    {
      id: 'welcome-home',
      title: '화분 물주기',
      date: toDateKey(today),
      kind: 'routine',
      category: 'routine',
      completedDates: [toDateKey(today)],
      repeat: 'weekly',
    },
    {
      id: 'welcome-shopping',
      title: '장보기',
      date: toDateKey(tomorrow),
      time: '15:00',
      kind: 'task',
      category: 'shopping',
      completedDates: [],
      repeat: 'none',
    },
  ]
}
